import * as React from "react";
import * as ReactDOM from "react-dom/client";
import "./components/i18next/i18n";

import "./index.css";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
